/* Senivya — Black Friday 2026 : comptes à rebours (barre du haut, accueil, fiches).
   Une seule date de fin réelle par compteur (data-end, ISO), jamais remise à zéro. */
(function () {
  function pad(n) { return n < 10 ? '0' + n : '' + n; }

  function setDigit(el, v) {
    if (el.textContent === v) return;
    el.textContent = v;
    el.classList.remove('is-tick');
    void el.offsetWidth;
    el.classList.add('is-tick');
    el.addEventListener('animationend', function () { el.classList.remove('is-tick'); }, { once: true });
  }

  function syncBarHeight() {
    var bar = document.querySelector('.snv-bf-bar');
    var h = bar && bar.offsetParent !== null ? bar.offsetHeight : 0;
    document.documentElement.style.setProperty('--snv-bfh', h + 'px');
  }

  function tick() {
    var now = Date.now();
    document.querySelectorAll('[data-snv-cd]').forEach(function (cd) {
      var end = Date.parse(cd.getAttribute('data-end'));
      if (isNaN(end)) return;
      var left = Math.max(0, Math.floor((end - now) / 1000));
      if (left === 0) {
        var box = cd.closest('[data-snv-cd-hide]');
        if (box && !box.hidden) { box.hidden = true; syncBarHeight(); }
      }
      var v = {
        d: Math.floor(left / 86400),
        h: Math.floor((left % 86400) / 3600),
        m: Math.floor((left % 3600) / 60),
        s: left % 60
      };
      if (cd.getAttribute('data-format') === 'inline') {
        var txt = v.d + 'd ' + pad(v.h) + ':' + pad(v.m) + ':' + pad(v.s);
        if (cd.textContent !== txt) cd.textContent = txt;
        return;
      }
      ['d', 'h', 'm', 's'].forEach(function (u) {
        var el = cd.querySelector('[data-u="' + u + '"]');
        if (el) setDigit(el, pad(v[u]));
      });
    });
  }

  function start() {
    tick();
    syncBarHeight();
    setInterval(tick, 1000);
    window.addEventListener('resize', syncBarHeight);
    document.documentElement.classList.add('snv-bf-ready');
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();
